import { Sparkles } from "@/icons";
import { cn } from "@/lib/utils";

/**
 * Consistent "Concept Project" marker.
 * Every showcased project uses this until real client work is available.
 */
export function ConceptBadge({
  className,
  accent,
}: {
  className?: string;
  accent?: string;
}) {
  return (
    <span
      data-testid="concept-badge"
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold uppercase tracking-[0.12em] backdrop-blur",
        className,
      )}
      style={
        accent
          ? { borderColor: `${accent}55`, color: accent, background: `${accent}12` }
          : undefined
      }
    >
      <Sparkles className="h-3 w-3" />
      Featured Project
    </span>
  );
}
